export function getProp(obj, path) {
  if (!obj || !path) {
    return undefined
  }
  if (!path.includes('.')) {
    return obj[path]
  }
  return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj)
}

export function getOptionValue(opt, valueProperty = 'id') {
  const v = getProp(opt, valueProperty) ?? opt.id ?? opt.value ?? opt.internalName
  if (v === undefined || v === null) {
    return ''
  }
  return String(v)
}

export function getOptionLabel(opt, labelProperty = 'name') {
  if (!opt) {
    return ''
  }
  if (opt.label) {
    return opt.label
  }

  const labelFromProp = getProp(opt, labelProperty)
  if (labelFromProp) {
    return labelFromProp
  }

  if (opt.name) {
    return opt.name
  }
  if (opt.user && opt.user.name) {
    return opt.user.name
  }

  return opt.id ?? ''
}
